
var config = {
  db: {
    options: {
      maxPoolSize: 100,
      // useNewUrlParser: true,
      // useUnifiedTopology: true,
      maxIdleTimeMS: 30000, // Tiempo máximo en ms que una conexión puede estar inactiva
      connectTimeoutMS: 10000, // Tiempo de espera para conexiones iniciales
      socketTimeoutMS: 45000, // Tiempo de espera para operaciones de red
      bufferCommands: false, // Disable mongoose buffering
      // native_parser: true,
      // useMongoClient: true,
      // replset: { rs_name: 'myReplicaSetName' },
      user: process.env.MONGO_USER,
      pass: process.env.MONGO_PASS
    },
    options_debug: {
      autoIndex: false, // Don't build indexes
      // reconnectTries: Number.MAX_VALUE, // Never stop trying to reconnect
      // reconnectInterval: 500, // Reconnect every 500ms
      // bufferMaxEntries: 0,
      bufferCommands: false, // Disable mongoose buffering
      // useNewUrlParser: true,
      // useUnifiedTopology: true,
      maxPoolSize: 100,
      maxIdleTimeMS: 30000, // Tiempo máximo en ms que una conexión puede estar inactiva
      connectTimeoutMS: 10000, // Tiempo de espera para conexiones iniciales
      socketTimeoutMS: 45000 // Tiempo de espera para operaciones de red
      // native_parser: true,
      // useMongoClient: true
      // replset: { rs_name: 'myReplicaSetName' },
    },
    uri_debug: process.env.MONGO_URL_DEBUG,
    uri: process.env.MONGO_URL
  },
  host_uri: 'https://play.mainchess.com',
  host_uri_debug: 'https://localhost',
  stream_uri: 'https://stream.mainchess.com',
  stream_uri_debug: 'https://localhost:2053',
  video_uri: 'https://video.mainchess.com',
  video_uri_debug: 'https://localhost:2083',
  porthttp: process.env.PORT || 2023,
  porthttp_debug: process.env.PORT || 443,
  multicore: false,
  https: true,
  debug: false,
  ipaddr: '',
  debug_info: false,
  simulate_users: false,
  autotournament: false,
  retransmision: true
}
module.exports = config



// WEBPACK FOOTER //
// ./server/config.js